// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFileOutlinedSvg from "@fishx/icons-svg/es/asn/PFileOutlined";
import FishxIcon from '../components/FishxIcon';

var PFileOutlined = function PFileOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFileOutlinedSvg
  }));
};

PFileOutlined.displayName = 'PFileOutlined';
export default React.forwardRef(PFileOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFileOutlined.js
// module id = 3396
// module chunks = 0